export const ContractConditionTypes = {
  USER_TERMS: 'USER_TERMS',
  OTP_DATA_PASSING: 'OTP_DATA_PASSING',
  RECURRING_PAYMENT: 'RECURRING_PAYMENT'
}
